import { useEffect, useState } from "react";
import { MobileNavbar } from "../Commons/Navigation/Navigation";
import { HomePageContent } from "./HomePage";

export function PortraitWarning() {
    const [isPortrait, setIsPortrait] = useState(false);

    useEffect(() => {
        const checkOrientation = () => {
            setIsPortrait(window.innerHeight > window.innerWidth);
        };

        checkOrientation(); // Run once on mount
        window.addEventListener("resize", checkOrientation);

        return () => window.removeEventListener("resize", checkOrientation);
    }, []);

    if (!isPortrait) return null;

    return (
        <div className="portrait-warning position-fixed top-0 start-0 w-100 h-100 bg-dark text-white d-flex justify-content-center align-items-center z-3">
            <div className='mobile-warning position-relative homepage w-100 h-100 overflow-y-scroll'>
                <MobileNavbar />
                <HomePageContent />
            </div>
        </div>
    );
}